<template>
  <!-- eslint-disable vue/no-lone-template -->
  <div class="booking-customer-list">
    <div class="list row mb-3">
      <div class="head col-8">ประวัติการจอง</div>
    </div>
    <div class="">
      <div v-if="noResult" class="p-4 text-center">ไม่มีข้อมูล</div>
      <template v-else>
        <p class="ms-4 mb-3">{{ totalCount }}</p>
        <div class="row">
          <booking-customer-list-row
            v-for="item in bookList"
            :key="item.bookNumber"
            v-bind="item"
          ></booking-customer-list-row>
        </div>
      </template>
    </div>
    <div class="wrapper text-end padding-adjust">
      <el-pagination
        :total="total"
        :page-size="query.take"
        :current-page="query.page"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies"
import { Pagination } from "element-ui"
import { conferenceBookingStatus } from "@/lib/mapper"
import { convertDateTimeToTimeText } from "@/lib/dateTime"
import { timeDurationDropdown } from "../VariableStatic"
import BookingCustomerListRow from "./BookingCustomerListRow"

export default {
  components: {
    "el-pagination": Pagination,
    BookingCustomerListRow,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
  },
  data() {
    const title = "รายการจอง"

    const query = {
      bookingNo: null,
      page: 1,
      take: 20,
    }

    return {
      title,
      query,
      bookList: [],
      total: 0,
    }
  },
  computed: {
    noResult() {
      return this.bookList.length === 0
    },
    conferenceBookingStatusDropdown() {
      return conferenceBookingStatus
    },
    totalCount() {
      const limit = this.query.take
      const total = this.total.toLocaleString()
      const currentTotalItem = this.bookList.length

      const isLastPage = limit > currentTotalItem
      const currentPage = +this.query.page || 1
      const end = isLastPage ? total : currentPage * limit
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString()

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`
    },
  },
  watch: {
    "$route.query": function routeQueryWatcher() {
      this.setFormBookList()

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0
    },
    value() {
      this.setFormBookList()
    },
  },
  created() {
    this.setFormBookList()
  },
  methods: {
    setFormBookList() {
      this.setupForm()
      this.setupBookList()
    },
    setupForm() {
      this.query = {
        bookingNo: this.$route.query.bookingNo || null,
        room: this.$route.query.room || null,
        status: this.$route.query.status || null,
        page:
          this.$route.query.page && this.$route.query.page !== ""
            ? +this.$route.query.page || 1
            : 1,
        firstName: this.$route.query.firstName || null,
        lastName: this.$route.query.lastName || null,
        take: this.query.take,
      }
    },
    async setupBookList() {
      const { data, total } = await this.fetchBookList()

      this.total = total
      if (data.length === 0) this.bookList = null

      this.bookList = data.map((bookDetail) => {
        const name = `${bookDetail.first_name || "-"} ${bookDetail.last_name || "-"}`
        const mobile = bookDetail.mobile || "-"
        const email = bookDetail.email || "-"
        const roomType = bookDetail.room_type
        const bookingStatus = conferenceBookingStatus.find(
          (stat) => stat.value === bookDetail.status,
        )

        const roomDates =
          bookDetail.booking_date && bookDetail.booking_date.length > 0
            ? bookDetail.booking_date.map((bookDate) => {
                const timeDuration = timeDurationDropdown.find(
                  (time) => time.value === bookDate.time_duration,
                )

                return {
                  date: convertDateTimeToTimeText(bookDate.date, "dd MMM yyyy"),
                  timeDuration: timeDuration ? timeDuration.label : "-",
                  numberOfPeople: bookDate.number_of_people,
                }
              })
            : undefined

        const bookingDate = roomDates
          ? roomDates
              .map(
                (date, dateIndex) =>
                  `${dateIndex + 1}. ${date.date} ${date.timeDuration} ${date.numberOfPeople} คน`,
              )
              .join("\n")
          : undefined

        const roomImage = roomType.images[0]

        return {
          bookNumber: bookDetail.id,
          customerDetail: `${name}\n${mobile}\n${email}`,
          roomTitle: (roomType && roomType.title) || "",
          bookingDate,
          status: bookingStatus || { label: "unknown", value: "UNKNOWN" },
          roomImage,
        }
      })
    },
    async fetchBookList() {
      try {
        const query = {
          email: this.value,
          mobile: this.value,
          booking_no: this.value,
          page: this.query.page,
          take: this.query.take,
        }

        return await baanRueJaiClient.others.conference.getUserBooks(query)
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
        return { data: [], total: 0 }
      }
    },
    handleSearch() {
      if (!this.$route.query || +this.query.page === +this.$route.query.page) {
        this.query.page = 1
      }

      this.$router.push({ query: this.query })
    },
    handleCurrentChange(page) {
      const query = { ...this.$route.query, page }

      this.$router.push({ query })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
@import "../../css/otherWebVariables.scss";

.filter {
  padding: 20px;
}

.search-button {
  float: right;
  margin-top: 10px;
}

.header {
  padding: 30px;
  border-bottom: $border;
}

.head {
  color: $color-orange;
  font-size: $font-30;
  font-weight: bold;
}

.list {
  padding-bottom: 10px;
  border-bottom: 3px solid $color-orange;
}
</style>
